import React, { Component } from 'react';

import { SelectLanguages } from 'components/input/select';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

@inject((stores) => ({
  supportedLanguages: stores.SubtitleStore.supportedLangs
}))
@observer
export default class SubtitleSupportedLangs extends Component {
  static propTypes = {
    supportedLanguages: PropTypes.array,
    mediaId: PropTypes.string
  };

  render() {
    const { supportedLanguages, mediaId, ...props } = this.props;

    return (
      <SelectLanguages
        languages={supportedLanguages[mediaId]}
        mediaId={mediaId}
        {...props}
      />
    );
  }
}
